import { writable } from "svelte/store"

export const keyUp = writable(false)
export const keyDown = writable(false)
export const keyLeft = writable(false)
export const keyRight = writable(false)

export const keyQ = writable(false)
export const keyE = writable(false)

export const key1 = writable(false)
export const key2 = writable(false)
export const key3 = writable(false)

export const keySpace = writable(false)
export const keyShift = writable(false)
